<template>
  <div class="remote">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('remote.crumbs.L1')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('linkManage.title')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('remote.crumbs.L3')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel">
      <div class="panel-header panel-header__fix">
        <div class="panel-select-group">
          <span class="panel-header__desc">{{$t('remote.panel.title')}}</span>
          <div type="primary" class="panel-header-btn" @click="dialogVisible = true">{{$t('remote.panel.shareGuide')}}</div>
        </div>
      </div>

      <div class="panel-body">
        <el-form ref="addForm" :model="addForm" :rules="addFormRules" class="add-form">
          <el-form-item :label="$t('remote.form.productName')" class="addform-close-icon" prop="goods_name">
            <el-input v-model.trim="addForm.goods_name" :maxlength="50" ></el-input>
            <i class="el-input__icon el-icon-close" @click="addForm.goods_name = ''" v-if="addForm.goods_name !== ''"></i>
          </el-form-item>

          <el-form-item :label="$t('remote.form.quantity')" prop="quantity" class="fe_quantity">
            <el-input v-model.trim="addForm.quantity" :maxlength="5"></el-input>
          </el-form-item>

          <el-form-item :label="$t('remote.form.currency')" class="fe_el-select">
            <el-select v-model.trim="addForm.currency">
              <el-option v-for="item in currencyList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item :label="$t('remote.form.price')" class="addform-close-icon fe_unit-price" prop="unit_price">
            <el-input v-model.trim="addForm.unit_price" :maxlength="13"></el-input>
            <i class="el-input__icon el-icon-close" @click="addForm.unit_price = ''" v-if="addForm.unit_price !== ''"></i>
          </el-form-item>

          <el-form-item>
            <el-button @click="addRemoteForm('addForm')" :disabled="goods_info.length >= 10">{{$t('remote.form.add')}}</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="goods_info" class="add-table" :show-header="false" style="width: 100%">
          <el-table-column prop="goods_name"></el-table-column>
          <el-table-column prop="quantity">
            <template slot-scope="scope">
              <button class="reduce" @click="reduceQuantity(scope)">-</button>
              <span class="table-quantity">{{scope.row.quantity}}</span>
              <button class="increase" @click="increaseQuantity(scope)">+</button>
            </template>
          </el-table-column>
          <el-table-column prop="currency">
            <template slot-scope="scope">
              {{currencyList1[scope.row.currency]}}
            </template>
          </el-table-column>
          <el-table-column prop="unit_price"></el-table-column>
          <el-table-column prop="delete">
            <template slot-scope="scope">
              <a @click="handleDelete(scope)">{{ $t('remote.form.delete') }}</a>
            </template>
          </el-table-column>
        </el-table>

        <el-form :model="remoteForm" :rules="remoteFormRules" ref="remoteForm" class="remote-form" label-width="160px" label-position="left">
          <el-form-item :label="$t('remote.form.totalAmount')" class="close-icon">
            <el-select v-model.trim="remoteForm.totalCurrency" class="total-amount">
              <el-option v-for="item in currencyList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-form-item prop="totalAmount" class="sing-validte">
              <el-input v-model.trim="remoteForm.totalAmount" class="inputtotal-amount" disabled></el-input>
            </el-form-item>
          </el-form-item>

          <el-form-item :label="$t('remote.form.customerName')" class="close-icon" prop="customerName">
            <el-input v-model.trim="remoteForm.customerName" :maxlength="50" :placeholder="$t('remote.form.customerName')"></el-input>
            <i class="el-input__icon el-icon-close" @click="remoteForm.customerName = ''" v-if="remoteForm.customerName !== ''"></i>
          </el-form-item>

          <el-form-item :label="$t('remote.form.customerPhone')" class="close-icon">
            <el-form-item prop="customerPhoneRegion" class="sing-validte">
              <el-input v-model.trim="remoteForm.customerPhoneRegion"  class="region-phone_left" :maxlength="3" :class="{'phone-status': phoneStatus}" @blur="getphoneStatus"></el-input>
            </el-form-item>
            <el-form-item prop="customerPhone" class="sing-validte">
              <el-input v-model.trim="remoteForm.customerPhone" class="region-phone_right" :placeholder="$t('remote.form.customerPhone')" :maxlength="20" :class="{'phone-status': phoneStatus}" @blur="getphoneStatus"></el-input>
            </el-form-item>
            <i class="el-input__icon el-icon-close coustomer_phone_icon" @click="clearContent" v-if="remoteForm.customerPhone !== '' || remoteForm.customerPhoneRegion !== ''"></i>
            <div class="phone_font">{{ $t('remote.form.phone_font') }}</div>
          </el-form-item>

          <el-form-item :label="$t('remote.form.customerEmail')" class="close-icon" prop="customerEmail">
            <el-input v-model.trim="remoteForm.customerEmail" :maxlength="50" :placeholder="$t('remote.form.customerEmail')"></el-input>
            <i class="el-input__icon el-icon-close" @click="remoteForm.customerEmail = ''" v-if="remoteForm.customerEmail !== ''"></i>
          </el-form-item>

          <el-form-item :label="$t('remote.form.paymentDeadline')">
            <el-date-picker
              v-model.trim="remoteForm.paymentDeadline"
              type="date"
              :editable="false"
              :clearable="false"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('remote.form.logisticsMode.title')">
            <el-select v-model.trim="remoteForm.logisticsMode" @change="changeDate">
              <el-option v-for="item in logisticsModeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('remote.form.date')">
            <el-date-picker
              v-model.trim="remoteForm.date"
              type="date"
              :editable="false"
              :clearable="false"
              :disabled="dateStatus"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('remote.form.description')" class="count-number" prop="description">
            <el-input :rows="6" type="textarea" v-model.trim="remoteForm.description" :maxlength="500" @keyup.native="getCount" :placeholder="$t('remote.form.writeDescription')"></el-input>
            <span>{{count}}/500</span>
          </el-form-item>

        </el-form>

        <div class="underline"></div>

        <el-dialog
          :visible.sync="dialogVisible">
          <el-carousel indicator-position="outside" :autoplay="false" arrow="never" trigger="click">
            <el-carousel-item v-for="(item, $index) in swipperImages" :key="$index">
              <img :src="item.image" alt="">
            </el-carousel-item>
          </el-carousel>
        </el-dialog>

        <div class="footer">
          <a @click="returnToLinkList">{{$t('remote.btn.cancel')}}</a>
          <el-button class="remote-link" :disabled="btnStatus" @click="getRmotePayLink('remoteForm')">{{$t('remote.btn.link')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from 'config'
import qs from 'qs'
export default {
  data () {
    // 验证邮箱格式
    let emailValid = (rul, val, cb) => {
      if(!/^[\w-]+[\w-.]*@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*\.[a-zA-Z\d]{2,6}$/.test(val) && val !== '') {
        cb(this.$t('overseaForget.invalidEmail'))
      }else{
        cb()
      }
    }
    let validCustomerName = (rul, val, cb) => {
      if ((/[^\u4e00-\u9fa5_a-zA-Z 0-9()-]/g).test(val)) {
        cb(this.$t('remote.rules.otherValidMessage'))
      } else {
        cb()
      }
    }
    let numberValidQuantity = (rul, val, cb) => {
      if ((!/^[0-9]*$/.test(val) && val) || val <= 0) {
        cb(this.$t('remote.rules.quantityFormat'))
      } else {
        cb()
      }
    }
    let numberValidprice = (rul, val, cb) => {
      if (/^([0-9]?\d{1,10})(\.\d{1,2})?$/.test(val) && val > 0) {
        cb()
      } else {
        cb(this.$t('remote.rules.quantityFormat'))
      }
    }
    let numberValidPhone = (rul, val, cb) => {
      if (!/^[0-9]*$/.test(val) && val !== '') {
        // cb(this.$t('remote.rules.customerPhoneMessage'))
        cb('')
      } else {
        cb()
      }
    }
    let goodNameVlid = (rul, val, cb) => {
      if ((/[^\u4e00-\u9fa5_a-zA-Z 0-9()-]/g).test(val) && val !== '') {
        cb(this.$t('remote.rules.otherValidMessage'))
      } else {
        cb()
      }
    }
    let validRemark = (rul, val, cb) => {
      if ((/[-;&=<>%]/im).test(val)) {
        cb(this.$t('remote.rules.otherValidMessage'))
      } else {
        cb()
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      dialogVisible: false,
      swipperImages: [],
      addForm: {
        goods_name: '',
        quantity: '1',
        currency: '344',
        unit_price: ''
      },
      goods_info: [],
      remoteForm: {
        totalCurrency: '344',
        totalAmount: '',
        customerName: '',
        customerPhoneRegion: '',
        customerPhone: '',
        customerEmail: '',
        paymentDeadline: '',
        logisticsMode: '0',
        date: '',
        description: ''
      },
      count: 0,
      dateStatus: false,
      phoneStatus: false,
      btnStatus: false,
      currencyList: [
        // {name: this.$t('remote.form.hkd'), value: '344'}
        { name: 'HKD', value: '344' }
      ],
      currencyList1: {
        // '344': this.$t('remote.form.hkd'),
        '344': 'HKD',
      },
      logisticsModeList: [
        {name: this.$t('remote.form.logisticsMode.option2'), value: '2'},
        {name: this.$t('remote.form.logisticsMode.option3'), value: '1'},
        {name: this.$t('remote.form.logisticsMode.option4'), value: '0'}
      ],
      logisticsList: {
        '2': this.$t('remote.form.logisticsMode.option2'),
        '1': this.$t('remote.form.logisticsMode.option3'),
        '0': this.$t('remote.form.logisticsMode.option4')
      },
      addFormRules: {
        goods_name: [
          { validator: goodNameVlid, trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: this.$t('remote.rules.quantityRules'), trigger: 'blur' },
          { validator: numberValidQuantity, trigger: 'blur' }
        ],
        unit_price: [
          { required: true, message: this.$t('remote.rules.unitPriceRules'), trigger: 'blur' },
          { validator: numberValidprice, trigger: 'blur' }
        ]
      },
      remoteFormRules: {
        customerName: [
          { validator: validCustomerName, trigger: 'blur' }
        ],
        customerEmail: [
          { validator: emailValid, trigger: 'blur' }
        ],
        customerPhoneRegion: [
          { validator: numberValidPhone, trigger: 'blur' }
        ],
        customerPhone: [
          { validator: numberValidPhone, trigger: 'blur' }
        ],
        description: [
          { validator: validRemark, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (!this.remoteForm.paymentDeadline) {
      this.remoteForm.paymentDeadline = this.getPaymentDeadline()
    }
    if (window.sessionStorage.getItem('form')) {
      this.remoteForm = JSON.parse(window.sessionStorage.getItem('form'))
    }
    if (window.sessionStorage.getItem('goods_info')) {
      this.goods_info = JSON.parse(window.sessionStorage.getItem('goods_info'))
      for (let i = 0; i < this.goods_info.length; i++) {
        this.goods_info[i].index = i
      }
    }
    this.getLinkMessage()
    this.getQuantity()
    this.getSwipperImage()
  },
  methods: {
    getLinkMessage () {
      if (this.$route.query.link_id) {
        axios.get(`${config.oHost}/remotepay/link/pay_link_info`, {
          params: {
            link_id: this.$route.query.link_id,
            format: 'cors'
          }
        }).then(res => {
          let data = res.data
          if (data.respcd === config.code.OK) {
            this.goods_info = data.data.goods_info
            this.remoteForm.logisticsMode = this.logisticsList[data.data.link_info.delivery_type] || ''
            this.getQuantity()
          } else {
            this.$message.error(data.resperr)
          }
        })
      }
    },
    getCount () {
      this.count = this.remoteForm.description.length
    },
    addRemoteForm (addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.goodsInfo()
        }
      })
    },
    goodsInfo () {
      this.goods_info.push({
        goods_name: this.addForm.goods_name,
        quantity: this.addForm.quantity,
        currency: this.addForm.currency,
        unit_price: this.addForm.unit_price,
        total_price: (Number(this.addForm.quantity) * Number(this.addForm.unit_price) * 100 / 100).toFixed(2)
      })
      this.addForm.goods_name = ''
      this.addForm.unit_price = ''
      this.getQuantity()
    },
    handleDelete (item) {
      this.goods_info.splice(item.$index, 1)
      this.getQuantity()
    },
    reduceQuantity (item) {
      item.row.quantity > 1 ? item.row.quantity-- : 1
      this.getQuantity()
    },
    increaseQuantity (item) {
      if (item.row.quantity >= 99999) {
        return false
      }
      item.row.quantity++
      this.getQuantity()
    },
    getQuantity () {
      if (this.goods_info.length > 0) {
        let totalAmount = ''
        for (let i = 0; i < this.goods_info.length; i++) {
          if (this.goods_info[i].quantity && this.goods_info[i].unit_price) {
            totalAmount = (Number(totalAmount) + this.goods_info[i].quantity * this.goods_info[i].unit_price).toFixed(2)
            this.goods_info[i].total_price = (Number(this.goods_info[i].quantity) * Number(this.goods_info[i].unit_price) * 100 / 100).toFixed(2)
          }
        }
        this.remoteForm.totalAmount = totalAmount
      } else {
        this.remoteForm.totalAmount = ''
      }
    },
    getPaymentDeadline () {
      let date = new Date()
      let year, month, day
      year = date.getFullYear()
      month = date.getMonth() + 1
      day = (date.getDate() + 7).toString()
      if (month === 1 || month === 3 || month === 5 || month === 7 || month === 8 || month === 10 || month === 12) {
        if (day > 31) {
          month = month + 1
          day = day - 31
        }
        if (month > 12) {
          year = year + 1
          month = month - 12
        }
      } else if (month === 4 || month === 6 || month === 9 || month === 11) {
        if (day > 30) {
          month = month + 1
          day = day - 30
        }
        if (month > 12) {
          year = year + 1
          month = month - 12
        }
      } else if (month === 2) {
        if (day > 28) {
          month = month + 1
          day = day - 28
        }
      }
      let dateTime = `${year}/${month}/${day}`
      return dateTime
    },
    clearContent () {
      this.remoteForm.customerPhone = ''
      this.remoteForm.customerPhoneRegion = ''
    },
    adjustDate (deliveryDate) {
      let date = new Date(deliveryDate)
      let year, month, day
      year = date.getFullYear()
      month = date.getMonth() + 1
      day = date.getDate()
      let time = `${year}-${month}-${day}`
      return time
    },
    getRmotePayLink (remoteForm, addForm) {
      if (this.addForm.unit_price !== '' && this.addForm.quantity !== '') {
        this.goodsInfo()
      }
      if (this.goods_info.length === 0) {
        this.$message.error(this.$t('remote.rules.productMessage'))
        return false
      }
      this.$refs[remoteForm].validate((valid) => {
        if (valid) {
          let logisticsMode = this.remoteForm.logisticsMode
          if (logisticsMode === this.$t('remote.form.logisticsMode.option2')) {
            logisticsMode = 2
          } else if (logisticsMode === this.$t('remote.form.logisticsMode.option3')) {
            logisticsMode = 1
          } else if (logisticsMode === this.$t('remote.form.logisticsMode.option4')) {
            logisticsMode = 0
          }
          if (this.remoteForm.customerPhoneRegion || this.remoteForm.customerPhone) {
            if (this.remoteForm.customerPhoneRegion && this.remoteForm.customerPhone) {
              this.phoneStatus = false
            } else {
              this.phoneStatus = true
              return false
            }
          }
          let params = {
            goods_info: JSON.stringify(this.goods_info),
            total_amount: this.remoteForm.totalAmount,
            currency: this.remoteForm.totalCurrency,
            customer_name: this.remoteForm.customerName,
            customer_telephone: this.remoteForm.customerPhoneRegion && this.remoteForm.customerPhone ? this.remoteForm.customerPhoneRegion + '-' + this.remoteForm.customerPhone : '',
            customer_email: this.remoteForm.customerEmail,
            pay_close_date: this.adjustDate(this.remoteForm.paymentDeadline) + ' 23:59:59',
            logistics_type: logisticsMode,
            estimate_delivery_date: this.remoteForm.date ? this.adjustDate(this.remoteForm.date) : '',
            remark: this.remoteForm.description,
            format: 'cors',
          }
          this.btnStatus = true
          axios.post(`${config.oHost}/remotepay/link/create_pay_link`, qs.stringify(params)).then(res => {
            let data = res.data
            this.btnStatus = false
            if (data.respcd === config.code.OK) {
              window.sessionStorage.setItem('form', JSON.stringify(this.remoteForm))
              window.sessionStorage.setItem('goods_info', JSON.stringify(this.goods_info))
              this.$router.push({path: '/main/remotePay/remotePayDone', query: {link_id: data.data.link_id}})
            } else {
              this.$message.error(data.resperr)
            }
          })
        }
      })
    },
    getSwipperImage () {
      let value
      if (window.localStorage.getItem('lang')) {
        value = JSON.parse(window.localStorage.getItem('lang')).value
      } else {
        value = 'zh-CN'
      }
      if ( value === 'zh-CN') {
        this.swipperImages = [
          { image: '/static/img/share_chinese_1.svg' },
          { image: '/static/img/share_chinese_2.svg' },
        ]
      } else if (value === 'en') {
        this.swipperImages = [
          { image: '/static/img/share_english_1.svg' },
          { image: '/static/img/share_english_2.svg' },
        ]
      } else if (value === 'zh-TW') {
        this.swipperImages = [
          { image: '/static/img/share_chinesef_1.svg' },
          { image: '/static/img/share_chinesef_2.svg' },
        ]
      }
    },
    changeDate () {
      if (this.remoteForm.logisticsMode === '0' || this.remoteForm.logisticsMode === '1') {
        this.remoteForm.date = ''
        this.dateStatus = true
      } else {
        this.dateStatus = false
      }
    },
    getphoneStatus () {
      if (this.remoteForm.customerPhoneRegion && !this.remoteForm.customerPhone) {
        this.phoneStatus = true
      } else if (!this.remoteForm.customerPhoneRegion && this.remoteForm.customerPhone) {
        this.phoneStatus = true
      } else {
        this.phoneStatus = false
      }
    },
    returnToLinkList () {
      this.$router.push({path: '/main/remotePay'})
    }
  },
}
</script>

<style lang="scss">
  .remote {
    .panel {
      .panel-header__fix {
        padding-right: 15px;
        line-height:50px;
        .panel-select-group {
          justify-content: space-between;
          line-height: 50px;
          .panel-header__desc {
            font-size: 18px;
            color: #FE9B20;
            float:left;
          }
          .panel-header-btn {
            width: 200px;
          }
        }
      }
      .panel-body { 
        padding-left: 25px;
        padding-right: 25px;
        border-bottom: 1px solid #ccc;
        .sing-validte {
          margin: 0 !important;
          display: inline-block;
        }
        .add-form {
          display: flex;
          margin-bottom: 15px;
          .el-form-item {
            justify-content: space-between;
            margin-right: 10px;
            flex: 3;
          }
          .fe_quantity, .fe_unit-price {
            position: relative;
            &::before {
              content: '*';
              color: red;
              position: absolute;
              left: 0;
              top: 13px;
            }
            .el-form-item__label {
              margin-left: 10px;
            }
          }
          .el-form-item:nth-child(1) {
            flex: 4;
          }
          .fe_el-select {
            .el-form-item__content {
              .el-select {
                width: 100%;
              }
            }
          }
          .addform-close-icon {
            .el-form-item__content {
              position: relative;
              .el-input {
                .el-input__inner {
                  padding-right: 27px;
                }
              }
              .el-icon-close {
                position: absolute;
                top: 18px;
                right: 0;
              }
            }
          }
          .el-form-item:nth-child(5) {
            display: flex;
            flex: 2;
            align-items: flex-end;
            .el-form-item__content {
              width: 100%;
              .el-button {
                width: 100%;
                background-color: #fe9b20;
                border-color: #fe9b20;
                span {
                  color: white;
                }
              }
            }
          }
        }
        .add-table {
          .el-table__body-wrapper {
            .el-table__body {
              colgroup {
                display: flex;
                col {
                  flex: 3;
                  justify-content: space-between;
                  margin-right: 10px;
                }
                col:nth-child(1) {
                  flex: 4;
                }
                col:nth-child(5) {
                  flex: 2;
                }
              }
              .el-table__row {
                display: flex;
                margin-bottom: 10px;
                td {
                  flex: 3;
                  border-bottom: none;
                  .cell {
                    padding-left: 0;
                    padding-right: 0;
                    line-height: 40px;
                    margin-left: 10px;
                    .reduce {
                      border: 1px solid #ccc;
                      border-radius: 21px;
                      height: 21px;
                      width: 21px;
                      background-color: #ffffff;
                      cursor: pointer;
                      outline: none;
                    }
                    .table-quantity {
                      display: inline-block;
                      width: 40px;
                      text-align: center;
                    }
                    .increase {
                      border: 1px solid #ccc;
                      border-radius: 21px;
                      height: 21px;
                      width: 21px;
                      background-color: #ffffff;
                      cursor: pointer;
                      outline: none;
                    }
                  }
                }
                td:nth-child(1) {
                  flex: 4;
                }
                td:nth-child(5) {
                  flex: 2;
                  .cell {
                    margin-left: 0;
                    a {
                      color: #E73B48;
                      &:hover {
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
            }
            .el-table__empty-block {
              display: none;
            }
          }
        }
        .remote-form {
          padding-bottom: 15px;
          margin-left: 10px;
          .el-input {
            width: 268px;
          }
          .el-form-item {
            margin: 20px 0;
            .total-amount {
              width: 80px;
              .el-input {
                width: 80px;
              } 
            }
            .inputtotal-amount {
              width: 179px;
              margin-left: 5px;
            }
          }
          .close-icon {
            .el-form-item__content {
              position: relative;
              .el-input {
                .el-input__inner {
                  padding-right: 27px;
                }
              }
              .region-phone_left {
                position: relative;
                width: 76px;
                &:before {
                  content: "+";
                  color: #C2C2C2;
                  position: absolute;
                  top: 0;
                  left: 10px;
                }
                .el-input__inner {
                  padding-left: 20px;
                  padding-right: 0;
                }
              }
              .region-phone_right {
                width: 179px;
                margin-left: 8px;
              }
              .el-icon-close {
                position: absolute;
                top: 0;
                left: 234px;
              }
              .coustomer_phone_icon {
                height: 38px;
              }
              .phone_font {
                font-size: 15px;
                line-height: 30px;
                margin-top: 10px;
              }
            }
          }
          .count-number {
            .el-form-item__content {
              position: relative;
              span {
                position: absolute;
                right: 10px;
                bottom: 0;
                color: #909297;
              }
            }
          }
        }
        .underline {
          border-bottom: 1px solid #E8E7E6;
        }
        .el-dialog__wrapper {
          .el-dialog {
            width: 700px;
            border-radius: 10px;
            .el-dialog__header {
              padding: 0;
              position: relative;
              .el-dialog__headerbtn {
                position: absolute;
                top: 0;
                right: -50px;
                background: none;
                .el-icon-close {
                  &::before {
                    font-size: 20px;
                  }
                }
              }
            }
            .el-dialog__body {
              padding: 0;
              height: 661px;
              width: 700px;
              .el-carousel {
                .el-carousel__container {
                  width: 700px;
                  height: 661px;
                  .el-carousel__item {
                    border-radius: 10px;
                    img: {
                      width: 100%;
                    }
                  }
                }
                .el-carousel__indicators {
                  .el-carousel__indicator {
                    .el-carousel__button {
                      height: 10px;
                      width: 10px;
                      border-radius: 10px;
                      background: none;
                      border: 1px solid #FFFFFF;
                    }
                  }
                  .is-active {
                    .el-carousel__button {
                      background: #FFFFFF;
                    }
                  }
                }
              }
            }
          }
        }
        .footer {
          height: 80px;
          display: flex;
          align-items: center;
          a {
            color: #ff9629;
            text-decoration: underline;
            margin-right: 28px;
            &:hover {
              cursor: pointer;
            }
          }
          .remote-link {
            background-color: #7ed321;
            border-color: #7ed321;
            padding-left: 25px;
            padding-right: 25px;
            span {
              color: white;
            }
          }
        }
      }
      .phone-status {
        .el-input__inner {
          border: none;
          border: 1px solid red;
          border-radius: 4px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// remotePay.vue?595d0e4f